import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Box, Text } from '@chakra-ui/react';
import Gallery, { GalleryImage } from '../components/Gallery';
import Breadcrumb from '../components/Breadcrumb';

const Moments = () => {
  const { t } = useTranslation('navigation');
  const { lng } = useParams<{ lng: string }>();
  const currentLanguage = lng || 'en';

  const getLocalizedPath = (path: string) => {
    const cleanPath = path.startsWith('/') ? path : `/${path}`;
    return `/${currentLanguage}${cleanPath}`;
  };
  const momentsImages: GalleryImage[] = [
    { src: '/images/moments/moment1.jpg', alt: 'Candid film photography moment - Event photography Costa del Sol' },
    { src: '/images/moments/moment2.jpg', alt: 'Authentic analog photography - Festival photography Marbella' },
    { src: '/images/moments/moment3.jpg', alt: 'Film photography candid moment - Event photographer Estepona' },
    { src: '/images/moments/moment4.jpg', alt: 'Spontaneous film capture - Corporate event photography Costa del Sol' },
    { src: '/images/moments/moment5.jpg', alt: 'Analog photography street moment - Documentary film photographer Marbella' },
    { src: '/images/moments/moment6.jpg', alt: 'Film photography celebration - Party photography Malaga' },
    { src: '/images/moments/moment7.jpg', alt: 'Candid event moment on film - Professional event photographer Spain' },
    { src: '/images/moments/moment8.jpg', alt: 'Authentic film photography - Cultural event photography Costa del Sol' },
    { src: '/images/moments/moment9.jpg', alt: 'Film photography lifestyle moment - Event photographer Sotogrande' },
    { src: '/images/moments/moment10.jpg', alt: 'Analog photography candid shot - Festival photographer Marbella' },
    { src: '/images/moments/moment11.jpg', alt: 'Film photography genuine moment - Sport event photography Costa del Sol' },
    { src: '/images/moments/moment12.jpg', alt: 'Documentary film photography - Event photography Estepona' },
    { src: '/images/moments/moment13.jpg', alt: 'Candid analog photography - Private party photographer Marbella' },
    { src: '/images/moments/moment14.jpg', alt: 'Film photography authentic moment - Corporate photographer Malaga' },
    { src: '/images/moments/moment15.jpg', alt: 'Spontaneous film capture - Cultural celebration photography Costa del Sol' },
    { src: '/images/moments/moment16.jpg', alt: 'Event film photography - Professional photographer Marbella' },
    { src: '/images/moments/moment17.jpg', alt: 'Analog photography lifestyle - Festival photography Estepona' },
    { src: '/images/moments/moment18.jpg', alt: 'Film photography genuine emotion - Event photographer Costa del Sol' },
    { src: '/images/moments/moment19.jpg', alt: 'Candid film moment - Party photography Sotogrande' },
    { src: '/images/moments/moment20.jpg', alt: 'Documentary analog photography - Event photography Malaga' },
    { src: '/images/moments/moment21.jpg', alt: 'Film photography celebration moment - Corporate event photographer Marbella' },
    { src: '/images/moments/moment22.jpg', alt: 'Authentic film capture - Sport photography Costa del Sol' },
    { src: '/images/moments/moment23.jpg', alt: 'Analog photography candid scene - Festival photographer Estepona' },
    { src: '/images/moments/moment24.jpg', alt: 'Film photography spontaneous moment - Event photographer Spain' },
    { src: '/images/moments/moment25.jpg', alt: 'Professional film photography - Cultural event photographer Costa del Sol' },
  ];

  return (
    <Box maxW="1200px" mx="auto" p={4} paddingTop={{ base: "80px", md: "20px" }}>
      {/* Breadcrumb */}
      <Box mb={6}>
        <Breadcrumb 
          items={[
            { label: t('breadcrumbs.work'), href: getLocalizedPath('/') },
            { label: t('breadcrumbs.moments') }
          ]} 
        />
      </Box>

      <Text fontSize="3xl" fontWeight="bold" mb={4} mt={4} textAlign="center">
        {t('breadcrumbs.moments')}
      </Text>
      <Gallery
        images={momentsImages}
        columns={{ base: 1, md: 2, lg: 2}}
        spacing={3}
      />
    </Box>
  );
};

export default Moments;